const { Default: _, match } = require('@nike/rcf-fp');

const { NPOS, MOMENT_DATE_FORMAT } = require('../../../../../utils/constants');

const circleStyle = {
  border: '1px solid #000',
  borderRadius: '40px',
  fontSize: '16px',
  fontWeight: 'bold',
  paddingBottom: 0,
  paddingLeft: '10px',
  paddingRight: '10px',
  paddingTop: 0,
  zIndex: 10000,
};

const getTimeRange = (startTime, endTime, timeRange = []) => {
  if (startTime.isBefore(endTime)) {
    const updatedTimeRange = [
      ...timeRange,
      {
        label: startTime.format('h:mm A'),
        value: startTime.format('HH:mm:ss'),
      },
    ];
    const updatedStartTime = startTime.clone().add(1, 'hour');
    return getTimeRange(updatedStartTime, endTime, updatedTimeRange);
  }
  return timeRange;
};

const getDateStyles = (date, startDate, endDate, timezone, moment) => {
  const isStartOrEndDate = moment(date).isSame(startDate, 'day') || moment(date).isSame(endDate, 'day');
  const isDateInRange = moment(date).isBetween(startDate, endDate, 'day', '[]');
  const isFutureDate = moment(date).isAfter(moment.tz(timezone).format(MOMENT_DATE_FORMAT));
  const isToday = moment(date).isSame(new Date(), 'day');

  const dateStyle = (isToday && !isDateInRange ? circleStyle : {});

  const textColorStyle = match()(
    [() => isFutureDate, NPOS.COLORS.DATEPICKER.FUTURE_DATE],
    [() => isStartOrEndDate, NPOS.COLORS.DATEPICKER.START_END_DATE],
    [_, NPOS.COLORS.DATEPICKER.DEFAULT]
  );

  return { dateStyle, textColorStyle };
};

const populateTimeRange = (includeDayEndTime = false, moment) => {
  const startTime = moment().startOf('day');
  const endTime = moment().endOf('day');
  return [...getTimeRange(startTime, endTime), ...(includeDayEndTime ? [NPOS.DAY_END_TIME] : [])];
};

const convertDateToTimezone = (dateRange, timeRange, storeTimezone, moment) => {
  const startTime = (timeRange.from.value);
  const endTime = (timeRange.to.value);
  const startDateWithTime = moment.tz(`${moment(dateRange.startDate).format(MOMENT_DATE_FORMAT)} ${startTime}`, storeTimezone).utc().format();
  const endDateWithTime = moment.tz(`${moment(dateRange.endDate).format(MOMENT_DATE_FORMAT)} ${endTime}`, storeTimezone).utc().format();
  return { end: endDateWithTime, start: startDateWithTime };
};

module.exports = {
  convertDateToTimezone, getDateStyles, getTimeRange, populateTimeRange
};
